import { render, staticRenderFns } from "./kitchen-display.vue?vue&type=template&id=0e2792ae&scoped=true"
import script from "./kitchen-display.vue?vue&type=script&lang=js"
export * from "./kitchen-display.vue?vue&type=script&lang=js"
import style0 from "./kitchen-display.vue?vue&type=style&index=0&id=0e2792ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2792ae",
  null
  
)

export default component.exports